var sensors = require("sa-sdk-javascript");
import { dataAccessUrl } from "@domain";

window.sensors = sensors; // 屏蔽开关 window.sensors = null

if (window.sensors) {
  let platformVersionData = {
    version: "v2", // 版本号
    platform:"partner", // 平台
  }
  sensors.init({
    server_url: `${dataAccessUrl}/dataAccess/v1/point/dataAccess`,
    show_log: false,
    heatmap: {
      //default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: "default",
      //default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭。
      scroll_notice_map: "default",
      scroll_delay_time: 4000,
      scroll_event_duration: 18000, //单位秒，预置属性停留时长 event_duration 的最大值。默认5个小时，也就是300分钟，18000秒。
      custom_property: function(element_target) {
        let trackParams = element_target.getAttribute("track-id");
        if (trackParams) {
          let trackParamsResult = trackParams.split('&&')
          let trackId = trackParamsResult[0] || ''
          let track_name = trackParamsResult[1] || ''
          let track_extensions = JSON.stringify((new Function("return "+ trackParamsResult[2]))()) || ''
          return {
            track_id: trackId,
            track_name,
            track_extensions: JSON.stringify(track_extensions),
            ...platformVersionData
          };
        }else{
          return {
              ...platformVersionData
          }
       }
      },
      loadTimeout: 3000 // 设置多少毫秒后开始渲染点击图,因为刚打开页面时候页面有些元素还没加载。
    },
    // is_track_single_page: true, // 表示是否开启单页面自动采集 $pageview 功能，SDK 会在 url 改变之后自动采集web页面浏览事件 $pageview。
    is_track_single_page: function (){
      return platformVersionData
    },
    batch_send: true, // 表示不开启批量发送，设置为 true 表示开启批量采集。
    cross_subdomain: true, // 设置成 true 后，表示在根域下设置 cookie 。也就是如果你有 zhidao.baidu.com 和 tieba.baidu.com 两个域，且有一个用户在同一个浏览器都登录过这两个域的话，我们会认为这个用户是一个用户。如果设置成 false 的话，会认为是两个用户。
    datasend_timeout: 3000, // 表示数据发送超时时间，如果数据发送超过 datasend_timeout 还未返回结果，会强制取消该请求。
    queue_timeout: 300, // 表示队列发送超时时间，如果数据发送时间超过 queue_timeout 还未返回结果，会强制发送下一条数据。
    callback_timeout: 200 // 表示回调函数超时时间，如果数据发送超过 callback_timeout 还未返回结果，会强制执行回调函数。
  });
  sensors.quick("autoTrack", platformVersionData);
}



// WEBPACK FOOTER //
// ./src/common/data-access.js